<router-outlet></router-outlet>

<app-dev-mode></app-dev-mode>
